<main class="page">
  <!-- Illustrated Tokyo background: fills the whole screen -->
  <div class="bg" aria-hidden="true"></div>
  <!-- Orange veil: solid at top, fading out toward the bowls (matches storyboards) -->
  <div class="glow" aria-hidden="true"></div>

  <!-- The stage: a fixed-proportion frame on desktop and tablet, a plain centred column on mobile -->
  <div class="stage">
    <img class="logo" src="assets/logo.png" alt="Bento Bowl by St Pierres" width="600" height="397" />

    <!-- WIN lockup: semi-stacked hybrid on tablet-portrait, stacked elsewhere -->
    <picture class="lockup">
      <source media="(min-width:600px) and (orientation:portrait)" srcset="assets/win-landscape.png" />
      <img src="assets/win-portrait.png" alt="WIN a year of Bento Bowl" />
    </picture>

    <section class="entry" aria-labelledby="entry-heading">
      <h1 class="heading" id="entry-heading">Enter your purchase details below to go in the draw</h1>
      <p class="sub">100 weekly prizes up for grabs!</p>

      <form class="form" [formGroup]="entryForm">
        <div class="fields">
          <!-- First Name -->
          <div class="field field--first">
            <label for="firstName">First name</label>
            <input id="firstName" name="firstName" type="text" formControlName="firstName" autocomplete="given-name"
              [disabled]="isDisabled && !isManualEntry" required />
            <div class="error"
              *ngIf="entryForm?.get('firstName')?.touched && entryForm?.get('firstName')?.hasError('required')">
              First Name is required
            </div>
            @if (entryForm.controls['firstName'].errors?.['pattern'] && entryForm.controls['firstName'].touched) {
            <div class="error">First Name contain only letters, hyphens, or apostrophes</div>
            }
          </div>

          <!-- Last Name -->
          <div class="field field--last">
            <label for="lastName">Last name</label>
            <input id="lastName" name="lastName" type="text" formControlName="lastName" autocomplete="family-name"
              [disabled]="isDisabled && !isManualEntry" />
            @if (entryForm.controls['lastName'].errors?.['pattern'] && entryForm.controls['lastName'].touched) {
            <div class="error">Last Name contain only letters, hyphens, or apostrophes</div>
            }
          </div>

          <!-- Email -->
          <div class="field field--email">
            <label for="email">Email</label>
            <input id="email" name="email" type="email" formControlName="email" autocomplete="email"
              [disabled]="isDisabled && !isManualEntry" required />
            <div class="error"
              *ngIf="entryForm?.get('email')?.touched && entryForm?.get('email')?.hasError('required')">
              Email is required
            </div>
            @if (entryForm.controls['email'].hasError('email') && entryForm.controls['email'].errors?.['pattern']) {
            <div class="error">Please enter valid email.</div>
            }
          </div>

          <!-- Phone Number -->
          <div class="field field--phone">
            <label for="phone">Phone Number</label>
            <input id="phone" name="phone_number" type="tel" inputmode="tel" formControlName="phone_number" autocomplete="tel"
              maxlength="13" [disabled]="isDisabled && !isManualEntry" (keypress)="preventNonNumeric($event)"
              required />
            <div class="error"
              *ngIf="entryForm?.get('phone_number')?.touched && entryForm?.get('phone_number')?.hasError('required')">
              Phone Number is required
            </div>
            @if (entryForm.controls['phone_number'].hasError('minlength')) {
            <div class="error">Please enter valid phone number.</div>
            }
          </div>

          <!-- Receipt Number (Manual Entry) -->
          <div class="field field--receipt-no" *ngIf="isManualEntry">
            <div class="receipt-label-row">
              <label for="receiptNo1">Receipt Number</label>
              <a class="info-text" href="#" (click)="showHelpDialog(); $event.preventDefault();">
                <svg class="info-icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="currentColor"/><path fill="#fff" d="M11 17.2h2v2h-2zm1-12.4a3.9 3.9 0 0 0-3.9 3.9h2a1.9 1.9 0 1 1 3.24 1.34l-1.24 1.26A3.3 3.3 0 0 0 11 13.7v.8h2v-.4a2.6 2.6 0 0 1 .76-1.7l.9-.92A3.72 3.72 0 0 0 12 4.8"/></svg>Sample Receipt Number
              </a>
            </div>
            <div class="receipt-inputs">
              <input id="receiptNo1" name="field1" type="text" formControlName="field1" inputmode="numeric" maxlength="10" required />
              <span class="hyphen" aria-hidden="true">-</span>
              <input id="receiptNo2" name="field2" type="text" formControlName="field2" inputmode="numeric" maxlength="10" required />
              <span class="hyphen" aria-hidden="true">-</span>
              <input id="receiptNo3" name="field3" type="text" formControlName="field3" inputmode="numeric" (keypress)="preventNonNumeric($event)" maxlength="10" required />
            </div>
            <div class="error"
              *ngIf="(entryForm?.get('field1')?.touched && entryForm?.get('field1')?.hasError('required')) || (entryForm?.get('field2')?.touched && entryForm?.get('field2')?.hasError('required')) || (entryForm?.get('field3')?.touched && entryForm?.get('field3')?.hasError('required'))">
              Receipt Number is required
            </div>
          </div>

          <!-- Receipt Amount (Manual Entry) -->
          <div class="field field--receipt-amount" *ngIf="isManualEntry">
            <label for="receiptAmount">Receipt Amount</label>
            <input id="receiptAmount" name="receipt_amount" type="text" inputmode="decimal" placeholder="$0.00" formControlName="receipt_amount"
              (keypress)="preventNonNumericInRcAmount($event)" required />
            <div class="error"
              *ngIf="entryForm?.get('receipt_amount')?.touched && entryForm?.get('receipt_amount')?.hasError('required')">
              Receipt Amount is required
            </div>
          </div>
        </div>

        <!-- Fields and tail both flow inside .form -->
        <div class="tail">
          <div class="checks">
            <label class="check">
              <input type="checkbox" id="terms" name="terms_conditions" formControlName="terms_conditions"
                [disabled]="isDisabled && !isManualEntry" required />
              <span>
                I have read and understood the competition
                <a [routerLink]="['/terms-conditions']" [queryParams]="{ src:'tnc',ld:lucky_draw_hdr_id}"
                  target="_blank" class="check-link">terms and conditions</a>.
              </span>
            </label>

            <label class="check">
              <input type="checkbox" id="register_me" name="register_me" formControlName="register_me" required />
              <span>Register Me for the <b>Spend and Win Draw</b> on stpierres.online.</span>
            </label>

            <label class="check">
              <input type="checkbox" id="isSubscribed" name="isSubscribed" formControlName="isSubscribed"
                [disabled]="isDisabled && !isManualEntry" />
              <span>Sign me up to join the St Pierres Sushi Lovers Club for great deals, sushi news, competitions and more!</span>
            </label>
          </div>

          <button class="submit" type="button" (click)="onRegister()" [disabled]="registrationStatus === 1">
            <ng-container *ngIf="registrationStatus !== 1">Submit</ng-container>
            <ng-container *ngIf="registrationStatus === 1">
              Submitting <span class="spinner-border"></span>
            </ng-container>
          </button>

          <div class="social">
            <ul class="social__icons">
              <li>
                <a href="https://www.facebook.com/p/Bento-Bowl-by-St-Pierres-61572991943313/" target="_blank" aria-label="Facebook">
                  <svg class="soc-ic" viewBox="0 0 24 24" aria-hidden="true">
                    <circle cx="12" cy="12" r="12" fill="currentColor" />
                    <path fill="#fff" d="M13.2 19v-6.3h2.1l.32-2.45H13.2V8.7c0-.71.2-1.19 1.21-1.19h1.29V5.32A17.6 17.6 0 0 0 13.82 5.2c-1.86 0-3.13 1.14-3.13 3.22v1.83H8.57v2.45h2.12V19z" />
                  </svg>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/bentobowl.nz/" target="_blank" aria-label="Instagram">
                  <svg class="soc-ic" viewBox="0 0 24 24" aria-hidden="true">
                    <circle cx="12" cy="12" r="12" fill="currentColor" />
                    <path fill="#fff" d="M12 7.35c1.51 0 1.69.006 2.29.033.55.025.85.117 1.05.195.264.102.452.224.65.422.198.198.32.386.422.65.078.2.17.5.195 1.05.027.6.033.78.033 2.29s-.006 1.69-.033 2.29c-.025.55-.117.85-.195 1.05a1.75 1.75 0 0 1-.422.65 1.75 1.75 0 0 1-.65.422c-.2.078-.5.17-1.05.195-.6.027-.78.033-2.29.033s-1.69-.006-2.29-.033c-.55-.025-.85-.117-1.05-.195a1.75 1.75 0 0 1-.65-.422 1.75 1.75 0 0 1-.422-.65c-.078-.2-.17-.5-.195-1.05C7.356 13.69 7.35 13.51 7.35 12s.006-1.69.033-2.29c.025-.55.117-.85.195-1.05.102-.264.224-.452.422-.65.198-.198.386-.32.65-.422.2-.078.5-.17 1.05-.195.6-.027.78-.033 2.29-.033M12 6.33c-1.54 0-1.73.007-2.33.034-.61.028-1.02.124-1.39.264-.38.147-.7.344-1.02.665-.32.32-.518.64-.665 1.02-.14.37-.236.78-.264 1.39C6.337 10.27 6.33 10.46 6.33 12s.007 1.73.034 2.33c.028.61.124 1.02.264 1.39.147.38.344.7.665 1.02.32.32.64.518 1.02.665.37.14.78.236 1.39.264.6.027.79.034 2.33.034s1.73-.007 2.33-.034c.61-.028 1.02-.124 1.39-.264.38-.147.7-.344 1.02-.665.32-.32.518-.64.665-1.02.14-.37.236-.78.264-1.39.027-.6.034-.79.034-2.33s-.007-1.73-.034-2.33c-.028-.61-.124-1.02-.264-1.39a2.77 2.77 0 0 0-.665-1.02 2.77 2.77 0 0 0-1.02-.665c-.37-.14-.78-.236-1.39-.264-.6-.027-.79-.034-2.33-.034m0 2.76A2.91 2.91 0 1 0 12 14.91 2.91 2.91 0 0 0 12 9.09m0 4.8A1.89 1.89 0 1 1 12 10.11a1.89 1.89 0 0 1 0 3.78m3.71-4.91a.68.68 0 1 0 0 1.36.68.68 0 0 0 0-1.36" />
                  </svg>
                </a>
              </li>
              <li>
                <a href="https://www.tiktok.com/@stpierresnz" target="_blank" aria-label="TikTok">
                  <svg class="soc-ic" viewBox="0 0 24 24" aria-hidden="true">
                    <circle cx="12" cy="12" r="12" fill="currentColor" />
                    <path fill="#fff" d="M16.6 9.28a3.77 3.77 0 0 1-2.3-.77v3.96a3.48 3.48 0 1 1-3.48-3.48c.12 0 .23.01.35.02v1.72a1.78 1.78 0 1 0 1.4 1.74V5.2h1.68a3.78 3.78 0 0 0 3.33 3.37z" />
                  </svg>
                </a>
              </li>
            </ul>
            <nav class="social__legal" aria-label="Legal">
              <a [routerLink]="['/terms-conditions']" [queryParams]="{ src:'tnc',ld:lucky_draw_hdr_id}" target="_blank">Terms &amp; Conditions</a>
              <a [routerLink]="['/terms-conditions']" [queryParams]="{ src:'pp',ld:lucky_draw_hdr_id}" target="_blank">Privacy Policy</a>
            </nav>
          </div>
        </div>
      </form>
    </section>

    <!-- Three bowls, or the single hero bowl wherever the mobile layout applies -->
    <picture class="bowls" aria-hidden="true">
      <source media="(max-width:599px), (max-height:559px) and (max-width:1199px)" srcset="assets/bowl-hero.png" />
      <img src="assets/bowls.png" alt="" />
    </picture>
  </div>
</main>